const LINK_TYPE = {
  INTERNAL: "internal",
  EXTERNAL: "external",
};

export { LINK_TYPE };
